import { toastr } from 'react-redux-toastr';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';

export const setAccessLevels = createAction('SET_ACCESS_LEVELS');
export const setScopes = createAction('SET_SCOPES');

const initialState = {
	accessLevels: [],
	scopes: []
};

export default handleActions(
	{
		SET_ACCESS_LEVELS: (state, action) => ({ ...state, accessLevels: action.payload }),
		SET_SCOPES: (state, action) => ({ ...state, scopes: action.payload })
	},
	initialState
);

export const createAccessLevel = (accessLevel, scopes) => async () => {
	await Agent.createAccessLevel(accessLevel, scopes);
};
export const updateAccessLevel = (accessLevel) => async () => {
	await Agent.updateAccessLevel(accessLevel);
};
export const updateAccessLevelScopes = (id, scopes) => async () => {
	await Agent.updateAccessLevelScopes(id, scopes);
};
export const getAccessLevelScopes = (id) => async () => {
	const accessLevelScopes = await Agent.getAccessLevelScopes(id);
	return accessLevelScopes.data;
};
export const getAccessLevels = () => async (dispatch) => {
	const accessLevels = await Agent.getAdminAccessLevels();
	dispatch(setAccessLevels(accessLevels.data.sort((a, b) => (a.id < b.id ? -1 : 1))));
};
export const getScopes = () => async (dispatch) => {
	const scopes = await Agent.getScopes();
	dispatch(setScopes(scopes.data));
};

export const searchAccessLevels = (text) => async (dispatch) => {
	try {
		const accessLevels = await Agent.searchAdminAccessLevels(text);
		if (accessLevels.problem) {
			throw new Error(accessLevels.data);
		}
		const sortedData = accessLevels.data.sort((a, b) => (a.id < b.id ? -1 : 1));
		dispatch(setAccessLevels(sortedData));
	} catch (e) {
		toastr.error('Failed to search access levels', e.message);
	}
};
